// JWT 토큰 관리 유틸리티

// 토큰에서 만료 시간 추출
export function getTokenExpiration(token) {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * 1000; // 밀리초 단위로 변환
    } catch (error) {
        console.error('Token parsing error:', error);
        return null;
    }
}

// 토큰이 만료되었는지 확인
export function isTokenExpired(token) {
    if (!token) return true;
    
    const expiration = getTokenExpiration(token);
    if (!expiration) return true;
    
    return Date.now() >= expiration;
}

// 토큰 만료까지 남은 시간 (밀리초)
export function getTimeUntilExpiration(token) {
    if (!token) return 0;
    
    const expiration = getTokenExpiration(token);
    if (!expiration) return 0;
    
    return Math.max(0, expiration - Date.now());
}

// 자동 로그아웃 설정
export function setupAutoLogout(onLogout) {
    const checkTokenExpiration = () => {
        const token = localStorage.getItem('adminToken');
        
        if (isTokenExpired(token)) {
            console.log('Token expired, logging out...');
            onLogout();
            return;
        }
        
        // 다음 체크까지 남은 시간 계산 (최소 1분, 최대 5분)
        const timeUntilExpiration = getTimeUntilExpiration(token);
        const nextCheckDelay = Math.min(
            Math.max(timeUntilExpiration - 60000, 60000), // 만료 1분 전부터 1분마다 체크
            300000 // 최대 5분
        );
        
        setTimeout(checkTokenExpiration, nextCheckDelay);
    };
    
    // 즉시 첫 번째 체크 실행
    checkTokenExpiration();
    
    // 페이지 포커스 시에도 체크 (사용자가 탭을 다시 열었을 때)
    const handleFocus = () => {
        checkTokenExpiration();
    };
    
    window.addEventListener('focus', handleFocus);
    
    // 정리 함수 반환
    return () => {
        window.removeEventListener('focus', handleFocus);
    };
}

// 토큰 새로고침 시도
export async function tryRefreshToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    
    if (!refreshToken) {
        return false;
    }
    
    try {
        const response = await fetch('/api/auth/refresh', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refreshToken }),
        });
        
        if (response.ok) {
            const data = await response.json();
            localStorage.setItem('adminToken', data.access_token);
            localStorage.setItem('refreshToken', data.refresh_token);
            return true;
        }
    } catch (error) {
        console.error('Token refresh failed:', error);
    }
    
    return false;
}
